import { CIcon } from '~/icons/types'

export const ciUnderline: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 17.5c2.004 0 3.888-.78 5.303-2.196A7.449 7.449 0 0 0 19.5 10V4a1.5 1.5 0 1 0-3 0v6a4.467 4.467 0 0 1-1.319 3.182A4.466 4.466 0 0 1 12 14.5a4.47 4.47 0 0 1-3.182-1.318A4.47 4.47 0 0 1 7.5 10V4a1.5 1.5 0 1 0-3 0v6c0 2.003.78 3.887 2.196 5.303A7.45 7.45 0 0 0 12 17.5Zm8 1H4a1.5 1.5 0 1 0 0 3h16a1.5 1.5 0 0 0 0-3Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'underline',
  type: 'solid'
}
